<template>
  <div class="upload_media">
    <div
      id="template"
      class="image_preview"
    >
      <img data-dz-thumbnail>

      <span
        class="remove"
        data-dz-remove
      >
        <i class="fas fa-times-circle" />
      </span>

      <div class="details dropzone-tooltipster">
        <p
          class="name"
          data-dz-name
        />
        <p
          class="size"
          data-dz-size
        />

        <div class="progress_bar">
          <div
            aria-valuemax="100"
            aria-valuemin="0"
            aria-valuenow="0"
            class="progress active"
          >
            <div
              class="progress-bar progress-bar-striped progress-bar-animated progress-bar-success"
              data-dz-uploadprogress
              role="progressbar"
              style="width: 0%"
            />
          </div>
        </div>
        <div class="upload_success">
          <i class="fas fa-check-circle" />
        </div>
        <div class="upload_error text-danger">
          <svg-vue icon="icons/hazard_triangle" />
        </div>
      </div>
    </div>

    <div id="previews">
      <div class="message dz-message">
        <i class="far fa-cloud-download-alt" />
        <div class="innerMessage">
          {{ innerMessage }}
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="uploadErrors"
    class="upload_error_msg"
  >
    There are some issues with the files you've uploaded. Check the thumbnails for more info.
  </div>

  <div class="buttons">
    <secondary-button @click="$emit('close')">
      Close
    </secondary-button>
    <primary-button
      v-if="showUpload"
      class="upload"
      @click="enqueueFiles"
    >
      Upload
    </primary-button>
  </div>
</template>

<script>

import $ from 'jquery';
import {Dropzone} from 'dropzone'
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";

export default {
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    preventUpload: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
      required: true,
    },
    innerMessage: {
      type: String,
      default: 'Click here or drag and drop images to upload',
    },
    additionalXhrData: {
      type: Object,
      default: null,
    },
    limit: {
      type: Number,
      default: null,
    },
    acceptedFiles: {
      type: String,
      default: 'image/*'
    },
    invalidFileTypeMessage: {
      type: String,
      default: 'You cannot upload this file type'
    },
    thumbnailHeight: {
      type: Number,
      default: 125
    },
    thumbnailWidth: {
      type: Number,
      default: 125
    }
  },
  emits: [
    'close',
    'prevented',
    'uploadCompleted',
  ],
  data() {
    return {
      mediaDropzone: null,
      dropzoneConfig: {
        parallelUploads: 20,
        autoQueue: false,
        previewsContainer: "#previews",
        clickable: `#previews`,
      },
      previewNode: null,
      showUpload: false,
      xhrRequest: null,
      uploadErrors: false,
    }
  },
  mounted() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    this.initDropzone();
    let self = this;

    this.mediaDropzone.on("addedfile", function () {
      self.showUpload = this.files.length > 0;
      self.uploadErrors = false;
    });

    this.mediaDropzone.on("removedfile", function () {
      self.showUpload = this.files.length > 0;
      self.uploadErrors = false;
    });

    this.mediaDropzone.on("sending", function (file, xhr, formData) {
      formData.append("_token", csrfToken);
      if (self.additionalXhrData) {
        formData.append('additionalXhrData', JSON.stringify(self.additionalXhrData));
      }
    });

    this.mediaDropzone.on("success", function (file) {
      file.previewElement.querySelector('.upload_success').classList.add('active');
      file.previewElement.querySelector('.remove').style.display = 'none';
      file.previewElement.querySelector('.progress_bar').style.display = 'none';
    });

    this.mediaDropzone.on("error", function (file, message) {
      file.previewElement.querySelector('.upload_error').classList.add('active');
      file.previewElement.querySelector('.details').title = message.message ?? message;
      file.previewElement.querySelector('.progress_bar').style.display = 'none';
      $('.dropzone-tooltipster').tooltipster({
        contentAsHTML: true,
        theme: 'tooltipster-shadow',
        tooltipClass: 'tooltip-details',
        interactive: true
      });
      self.uploadErrors = true;
    });

    // Hide the total progress bar when nothing's uploading anymore
    this.mediaDropzone.on("queuecomplete", function () {
      const toastMsg =
          self.uploadErrors
              ? 'Files uploaded with some errors'
              : 'All files uploaded successfully'
      self.SweetToast.fire({
        icon: self.uploadErrors ? 'warning' : 'success',
        title: toastMsg,
      });
      self.showUpload = false;
      self.$emit('uploadCompleted');
    });

  },
  beforeUnmount() {
    this.mediaDropzone.destroy();
  },
  methods: {
    initDropzone() {
      // Get the template HTML and remove it from the document.
      this.previewNode = document.querySelector("#template");
      this.previewNode.id = "";

      this.dropzoneConfig.previewTemplate = this.previewNode.parentNode.innerHTML;
      this.dropzoneConfig.url = this.endpoint;
      this.dropzoneConfig.maxFiles = this.limit;
      this.dropzoneConfig.acceptedFiles = this.acceptedFiles;
      this.dropzoneConfig.dictInvalidFileType = this.invalidFileTypeMessage;
      this.dropzoneConfig.thumbnailHeight = this.thumbnailHeight;
      this.dropzoneConfig.thumbnailWidth = this.thumbnailWidth;
      this.mediaDropzone = new Dropzone(document.getElementById('previews'), this.dropzoneConfig);

      this.previewNode.parentNode.removeChild(this.previewNode);
    },
    enqueueFiles() {
      this.mediaDropzone.enqueueFiles(this.mediaDropzone.getFilesWithStatus(Dropzone.ADDED));
    },
    removeAllFiles() {
      this.mediaDropzone.removeAllFiles(true);
    }
  },
}
</script>

<style lang="scss" scoped>
.upload_media {

  #previews {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    height: 200px;
    overflow-y: auto;
    border: 2px dashed #37B2A8;
    border-radius: .75rem;
    cursor: pointer;

    .message {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #37B2A8;
      font-size: 2rem;

      i {
        font-size: 3rem;
        margin-bottom: 1rem;
      }
    }

    &.dz-started {
      .dz-message {
        display: none;
      }
    }

    &.dz-max-files-reached {
      pointer-events: none;
      cursor: default;
    }
  }

  .image_preview {
    position: relative;
    height: 127px;
    width: 127px;
    border: 1px solid var(--primary-color);
    border-radius: .5rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem;

    &.dz-error {
      border: 1px solid var(--negative-color);

      .details {
        background-color: rgba(198, 22, 22, .5);
        pointer-events: all;
        cursor: help;
      }
    }

    .remove {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1rem;
      padding: .25rem;
      color: var(--negative-color);
      pointer-events: all;
      cursor: pointer;

      &:hover {
        color: var(--negative-color-dark);
      }
    }

    .details {
      position: absolute;
      color: white;
      width: 70%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(0, 0, 0, .5);
      border-radius: .5rem;
      padding: .5rem;

      .name, .size {
        color: white;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .name, .error {
        font-size: .75rem;
        margin-bottom: 0;
      }

      .size {
        font-size: .6rem;
        margin-bottom: 0;
      }

      .progress_bar {
        width: 100%;
        font-size: .6rem;
        margin-bottom: 0;

        .progress {
          width: 100%;
          padding-right: 5px;
        }
      }

      .upload_success, .upload_error {
        width: 100%;
        text-align: center;
        display: none;

        &.active {
          display: block;
        }
      }

      .upload_success {
        color: var(--primary-color);
        font-size: 1.5rem;
      }

      .upload_error {

        :deep(svg) {
          height: 30px;
          width: 30px;

          path {
            stroke: var(--white);
            stroke-width: 1px;

            &:last-of-type {
              stroke: none;
              fill: var(--white);
            }
          }
        }

        color: var(--negative-color);
      }
    }
  }

}

.upload_error_msg {
  font-size: .75rem;
  text-align: right;
  width: 100%;
  margin-top: .5rem;
  color: var(--negative-color);
}

.buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;

  .upload {
    margin-left: .5rem;
  }
}
</style>
